import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// Shown briefly while a lazy-loaded route's JS chunk downloads.
const RouteLoadingFallback = () => (
    <div className="card-wrap" role="status" aria-label="Loading page">
        <div className="content">
            <Skeleton height={32} width={220} baseColor="var(--secondary-background-color-light)" highlightColor="var(--text-color)" />
            <Skeleton height={14} count={4} style={{ marginTop: 12 }} baseColor="var(--secondary-background-color-light)" highlightColor="var(--text-color)" />
        </div>
    </div>
);

export default RouteLoadingFallback;
